import { ITransportJobDao } from 'core/api/types/transport-job.interface';
import { TransportJobStatusLabels } from 'core/constants/transport-job-status';
import { createAddressString } from 'core/utilities/address-string-builder';
import dayjs from 'dayjs';

interface ITransportJobDetails {
  job: ITransportJobDao;
}

const TransportJobDetails = ({ job }: ITransportJobDetails) => {
  const details = [
    {
      key: 'status',
      label: 'Status',
      value: TransportJobStatusLabels[job.status],
    },
    ...(job.assigned
      ? [
          {
            key: 'assigned',
            label: 'Assignment',
            value: `${job.assigned.by.fullName}\n${dayjs(job.assigned.at.toDate()).format('DD/MM/YYYY HH:mm')}`,
          },
        ]
      : []),
    ...(job.completed
      ? [
          {
            key: 'completed',
            label: 'Completion',
            value: `${job.completed.by.fullName}\n${dayjs(job.completed.at.toDate()).format('DD/MM/YYYY HH:mm')}`,
          },
        ]
      : []),
    {
      key: 'name',
      label: 'Name',
      value: job.details.name,
    },
    {
      key: 'email',
      label: 'Email',
      value: job.details.email,
    },
    {
      key: 'manager',
      label: 'Manager',
      value: job.details.managerEmail,
    },
    {
      key: 'phone',
      label: 'Phone number',
      value: job.details.phoneNumber,
    },
    {
      key: 'site',
      label: 'Site',
      value: job.details.site,
    },
    {
      key: 'department',
      label: 'Department',
      value: job.details.department,
    },
    {
      key: 'collectionPoint',
      label: 'Collection/Pick-Up Point',
      value: job.details.collectionPoint,
    },
    {
      key: 'date',
      label: 'Date Required',
      value: job.details.date,
    },
    {
      key: 'time',
      label: 'Time Required',
      value: job.details.time,
    },
    {
      key: 'urgent',
      label: 'Urgent',
      value: job.details.urgent ? 'Yes' : 'No',
    },
    {
      key: 'destination',
      label: 'Destination',
      value: createAddressString(job.details.destination.formatted_address),
    },
    {
      key: 'costCode',
      label: '6-Digit Cost Code',
      value: job.details.costCode,
    },
    {
      key: 'reason',
      label: 'Reason for transport',
      value: job.details.reason,
    },
    {
      key: 'instructions',
      label: 'Special instructions',
      value: job.details.instructions,
    },
  ];

  return (
    <div className='flex-grow-0 flex-shrink-0 basis-[360px] bg-white shadow-md rounded-md'>
      <div className='border-b p-4 flex justify-between items-center'>
        <p className='headline-06'>Details</p>
      </div>
      <div className='p-4'>
        {details.map((section) => (
          <div key={section.key} className='mt-4 first:mt-0'>
            <p className='body-02 text-gray-500'>{section.label}</p>
            <p className='body-01 break-words whitespace-pre-wrap'>{section.value}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TransportJobDetails;
